import { LANGUAGE } from '@/constants'

/**
 * 默认多语言处理
 * 首次访问：以浏览器语言为主。支持简中、台湾繁中
 * 其他语言默认显示简中
 *
 * 二次访问：以用户上次访问时的语言为主
 * @returns
 */
export function getLocalLang() {
  const browserLang = LANGUAGE.map((it) => it.lang).includes(navigator.language) ? navigator.language : 'en'
  const local = window.localStorage.i18nextLng || browserLang

  const localLang = LANGUAGE.filter((item) => item.lang === local)

  return localLang
}
